// extracted by mini-css-extract-plugin
export default {"password":"PasswordResetForm_password__1kR72"};